var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "email-validation-modal",
      attrs: {
        visible: _vm.visible,
        centered: "",
        width: "620px",
        footer: null,
      },
      on: { cancel: _vm.handleClose },
    },
    [
      _c(
        "div",
        { staticClass: "email-validation" },
        [
          _c("div", { staticClass: "email-validation__icon" }, [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v("verified_user"),
            ]),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("E-posta adresinizi doğrulayın")]),
          _vm._v(" "),
          _c("p", { staticClass: "email-validation__lead" }, [
            _vm._v(
              "\n            Hesabınızın güvenliği ve kritik işlemlerde kimlik doğrulamasının sağlanması için\n            e-posta adresinizi doğrulamanız gerekiyor.\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "email-validation__notice" }, [
            _c("p", [
              _c("strong", [_vm._v("1 Temmuz 2026")]),
              _vm._v(
                " tarihinden sonra e-postası doğrulanmamış kullanıcılar\n                Supsis paneline giriş yapamayacak ve entegrasyon oluşturma gibi güvenlik açısından\n                hassas işlemleri tamamlayamayacaktır.\n            "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n                Ayrıca merkezi giriş ekranı "),
              _c("strong", [_vm._v("login.supsis.com")]),
              _vm._v(" ve\n                "),
              _c("strong", [_vm._v("supsis.ai")]),
              _vm._v(
                " sitesindeki “Giriş Yap” butonu yalnızca e-posta adresi\n                doğrulanmış kullanıcılar tarafından kullanılabilecektir.\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.step === 1
            ? [
                _c(
                  "div",
                  { staticClass: "email-validation__step" },
                  [
                    _c("label", [_vm._v("Doğrulanacak e-posta adresi")]),
                    _vm._v(" "),
                    _c(
                      "a-input",
                      {
                        attrs: {
                          value: _vm.user && _vm.user.email,
                          disabled: "",
                          size: "large",
                        },
                      },
                      [
                        _c("a-icon", {
                          attrs: { slot: "prefix", type: "mail" },
                          slot: "prefix",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "email-validation__step email-validation__step--pin",
                  },
                  [
                    _c("div", { staticClass: "email-validation__pin-card" }, [
                      _c(
                        "div",
                        { staticClass: "email-validation__pin-header" },
                        [
                          _c("div", [
                            _c("label", [_vm._v("6 haneli doğrulama kodu")]),
                            _vm._v(" "),
                            _vm.user && _vm.user.email
                              ? _c(
                                  "p",
                                  { staticClass: "email-validation__sent-to" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("mark_email_read")]
                                    ),
                                    _vm._v(
                                      "\n                                Kod "
                                    ),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.user.email)),
                                    ]),
                                    _vm._v(
                                      " adresine gönderildi\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "email-validation__timer",
                              class: {
                                "email-validation__timer--expired":
                                  _vm.isCodeExpired,
                              },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.isCodeExpired ? "schedule" : "timer"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isCodeExpired
                                        ? "Süre doldu"
                                        : "Kalan süre"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "strong",
                                  {
                                    staticClass:
                                      "email-validation__timer-value",
                                  },
                                  [_vm._v(_vm._s(_vm.formattedCountdown))]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "email-validation__pin-group",
                          on: {
                            paste: function ($event) {
                              $event.preventDefault()
                              return _vm.handlePinPaste.apply(null, arguments)
                            },
                          },
                        },
                        _vm._l(_vm.pinDigits, function (digit, index) {
                          return _c("input", {
                            key: index,
                            ref: "pinBox" + index,
                            refInFor: true,
                            staticClass: "email-validation__pin-box",
                            class: {
                              "email-validation__pin-box--filled": !!digit,
                              "email-validation__pin-box--error": _vm.pinError,
                            },
                            attrs: {
                              type: "text",
                              inputmode: "numeric",
                              maxlength: "1",
                              disabled: _vm.isCodeExpired,
                              autocomplete: "one-time-code",
                            },
                            domProps: { value: digit },
                            on: {
                              input: function ($event) {
                                return _vm.onPinInput(index, $event)
                              },
                              keydown: function ($event) {
                                return _vm.onPinKeydown(index, $event)
                              },
                              focus: function ($event) {
                                return _vm.onPinFocus(index)
                              },
                            },
                          })
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "email-validation__timer-progress" },
                        [
                          _c("span", {
                            style: { width: _vm.countdownProgress + "%" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "email-validation__pin-helper" },
                        [
                          _vm.isCodeExpired
                            ? [
                                _vm._v(
                                  "\n                            Kodun süresi doldu. Yeni kod göndererek tekrar deneyin.\n                        "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n                            Kod 5 dakika boyunca geçerlidir. Kodu kimseyle paylaşmayın.\n                        "
                                ),
                              ],
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "email-validation__resend",
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.loading ||
                            (!_vm.isCodeExpired && _vm.countdownSeconds > 240),
                        },
                        on: { click: _vm.resendCode },
                      },
                      [
                        _vm._v(
                          "\n                    Kodu tekrar gönder\n                    "
                        ),
                        !_vm.isCodeExpired && _vm.countdownSeconds > 240
                          ? _c("span", [
                              _vm._v(
                                "\n                        (" +
                                  _vm._s(_vm.formattedResendWait) +
                                  ")\n                    "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "email-validation__actions" },
            [
              _c(
                "a-button",
                { attrs: { size: "large" }, on: { click: _vm.handleClose } },
                [_vm._v("Daha sonra")]
              ),
              _vm._v(" "),
              _vm.step === 1
                ? _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "large",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.sendCode },
                    },
                    [
                      _vm._v(
                        "\n                Doğrulama kodu gönder\n            "
                      ),
                    ]
                  )
                : _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "large",
                        loading: _vm.loading,
                        disabled: _vm.isCodeExpired || _vm.pin.length !== 6,
                      },
                      on: { click: _vm.verifyCode },
                    },
                    [
                      _vm._v(
                        "\n                E-postamı doğrula\n            "
                      ),
                    ]
                  ),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }